<sc-master-detail [selection]="[selectedDefinition]" [data]="template.selectDefinitions"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);" [level]="2" class="template-lookup-editor no-field-space">

    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" *ngIf="selectedDefinition">

        <sc-padding>
            <ng-container [formGroup]="selectDefinitionFormGroup" *ngIf="selectedDefinition != null">
                <mat-form-field class="full-size-field" appearance="fill">
                    <mat-label>{{'identifier' | translate:['tmc-yard.entity.document-template-select-definition.identifier', translationService.language]}}</mat-label>
                    <input matInput name="identifier" formControlName="identifier"
                        [required]="true" [maxLength]="255">
                </mat-form-field>
            </ng-container>
        </sc-padding>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <sc-flex-fitting-content [vertical]="true">
            
            <app-template-lookup-field-editor [selectDefinition]="selectedDefinition" [template]="template"></app-template-lookup-field-editor>

        </sc-flex-fitting-content>

    </sc-flex>

</sc-master-detail>